import styled from '@emotion/styled';
import { TopDisplay } from '../../../ui-components';
import DisplayPayment from './DisplayPayment';
import {useState} from 'react'
import { ExNyRoute,PrRoute, ExRoute, AcRoute, MiRoute,  CoRoute } from '../../../utils/allRouteId';


const DATA_PER_PAGE = 10;

export const option1:any= [
  // {val:1, name:"Memembership Route",path:`${BASE_URL}`},
  // {val:2, name:"Examination / NYSC",path:`${BASE_URL}/examination`},
  {val:ExNyRoute, name:"Examination / NYSC",path:``},
  {val:PrRoute, name:"Practitioner",path:`practitional`},
  {val:ExRoute, name:"Executive",path:`executive`},
  {val:AcRoute, name:"Academic",path:`academic`},
  {val:MiRoute, name:"Military",path:`military`},
  {val:CoRoute, name:"Corporate",path:`corporate`}
]

export default function Payment() {

  const [routeName, setRouteName] = useState('');
  return (

      <>
        <ViewWrapper>
            <TopDisplay subTitle={routeName} title="Payments" />
            <DisplayPayment setRouteName = {setRouteName} />
        </ViewWrapper>
      </>
  )
}

export const ViewWrapper = styled.div`
  width: 100%;
  padding:0px 48px 48px 48px;

`